import React, { FC, useEffect, useMemo } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import { useSelector, useDispatch } from 'react-redux'

import SelectField from '@kaidam/fc-shared/src/frontend/components/form/fields/Select'

import {
  FormFieldProps,
} from '../../../types/form'

import astonishSelectors from '../../../store/selectors/astonish'
import astonishActions from '../../../store/modules/astonish'

const AstonishEmailTemplateSelect: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {
  const dispatch = useDispatch()
  const templates = useSelector(astonishSelectors.templates)
  const useProps = useMemo(() => {
    const {
      item,
    } = props
    const newItem = Object.assign({}, item, {
      options: templates.map(template => {
        return {
          title: template.name,
          value: template.id,
        }
      }),
    })
    return Object.assign({}, props, {
      item: newItem,
    })
  }, [
    props,
    templates,
  ])

  useEffect(() => {
    dispatch(astonishActions.loadTemplates())
  }, [])

  return (
    <SelectField
      { ...useProps }
    />
  )
}

export default AstonishEmailTemplateSelect